import React, { Component } from 'react';
import { getFile } from '../../../../../../utils/modelData';
import styles from './index.less';
import img1 from '../../images/blackground_2.png';

export default class IconModule extends Component {
  getImg = id => {
    return require(`../../images/icon/${id}.svg`);
  };

  render() {
    const { modules = [], picurl } = this.props;
    return (
      <div className={styles.module41}>
        <div className="bgImg" style={{ backgroundImage: `url(${picurl || img1})` }} />
        <div className="iconModule">
          {modules.map(item => {
            return (
              <div>
                {item.showIconType === 1 && (
                  <span style={{ backgroundImage: `url(${item.fileId})` }} />
                )}
                {item.showIconType === 0 && (
                  <span style={{ backgroundColor: getFile(item, 1) || '#D6D6D6' }}>
                    <img src={this.getImg(getFile(item, 0) || 'home')} alt="" />
                  </span>
                )}
                <span>{item.moduleName}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
